<div class="overview-cta" *ngIf="data">
    <div class="cta-container">
        <div class="cta-message" [ngClass]="{'empty': !title && !text}">
            <div class="title" *ngIf="title">
                <span [innerHTML]="title | safeHtml"></span>
                <span class="cta-popover-container" *ngIf="tooltip">
                    {{tooltipDescription}}
                    <finder-icon-tooltip class="cta-popover"
                        [tooltip]="tooltip"
                        [position]="'top-right'"
                        icon="&#58114;"
                    ></finder-icon-tooltip>
                </span>
            </div>
            <div *ngIf="text" class="cta-text" [innerHTML]="text | safeHtml"></div>
        </div>
        <div *ngIf="button" class="cta-button">
            <finder-button
                [href]="button.link"
                [target]="button.target"
                [theme]="'reversed'"
            >{{button.label}}</finder-button>
        </div>
    </div>
</div>
